function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function showMoney(m) {
    if (m.toString().indexOf(".") == -1) {
        return (m + ".00");
    }
    return m;
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}


jQuery(document).ready(function(e) {
    $(".currency-picker").change (function() {
        location.reload();
    });
    $(".buynow-action").hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 1000) {
            $('.buynow-action').fadeIn();
        } else {
            $('.buynow-action').fadeOut();
        }
    });
    jQuery('a[href="#ProductSection--product-template"]').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = jQuery(this.hash);
            target = target.length ? target : jQuery('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                jQuery('html,body').animate({
                    scrollTop: target.offset().top + 200
                }, 500);
                return false;
            }
        }
    });

    // Scroll to Top
    jQuery(document).on( 'scroll', function(){
        if (jQuery(window).scrollTop() > 500) {
            jQuery('.scrollTo').addClass('show');
        } else {
            jQuery('.scrollTo').removeClass('show');
        }
    });
    jQuery('.scrollTo').on('click', scrollToTop);
    function scrollToTop() {
        var verticalOffset, element, offset, offsetTop;
        verticalOffset = typeof(verticalOffset) != 'undefined' ? verticalOffset : 0;
        element = jQuery('body');
        offset = element.offset();
        offsetTop = offset.top;
        jQuery('html, body').animate({
            scrollTop: offsetTop
        }, 500, 'linear');
    }

    try {
        $("#topbar select").msDropDown();
    } catch(e) {
        alert(e.message);
    }

    // $('.thumbnail-pro').on('click', function(evt) {
    //     // var newImageId = $(this).attr('data-image-id');
    //     var activeThumbnails = $('.slider-nav').find('.slick-slide');
    //     activeThumbnails.removeAttr("active_thumb");
    //     $(this).attr( 'active_thumb', 'true' );
    // });

    $('a.search-click').on('click',function(){
        $('.show-search').fadeToggle();
        $('.show-search input.search-input').focus();
    });

    jQuery(window).scroll(function(){
        var height = 108;
        if (jQuery(window).scrollTop() > height) {
                jQuery('.w-sticky-view-cart').addClass('active');
        } else {
            jQuery('.w-sticky-view-cart').removeClass('active');
        }
    });

    // $( ".template-cart .wlo_pulltab_holder" ).remove();
    // // $( ".template-cart a[data-mfp-src='#SearchModal'], .template-cart .wrapper-search-m " ).remove();
    // var kai_klaClosedPopup = getCookie('klaUserSubscribed');
    // if (kai_klaClosedPopup == 1){
    //     $( ".wlo_pulltab_holder" ).remove();
    // }

    // Change line item quantity
    $('.template-cart .js-qty__adjust').click(function() {
        update_qty_item(this);
    });
    $('.template-cart .js-qty__num').change(function() {
        update_qty_item(this);
    });

    // adjustCart = function () {
    //     $body.on("click",".ajaxcart__qty-adjust",function(){
    //         if(!isUpdating){
    //             var a = $(this), b = a.data("line"), c = a.siblings(".ajaxcart__qty-num"), d = parseInt(c.val().replace(/\D/g,"")), d = validateQty(d);
    //             a.hasClass("ajaxcart__qty--remove") ? d=0:a.hasClass("ajaxcart__qty--plus")?d+=1:(d-=1,d<=0&&(d=0)), b?updateQuantity(b,d):c.val(d)
    //         }
    //     });
    //     $body.on("change",".ajaxcart__qty-num",function(){
    //         if(!isUpdating){
    //             var a=$(this), b=a.data("line"), c=parseInt(a.val().replace(/\D/g,"")), c=validateQty(c); b&&updateQuantity(b,c)
    //         }
    //     });
    //     $body.on("submit","form.ajaxcart",function(a){isUpdating&&a.preventDefault()});
    //     $body.on("focus",".ajaxcart__qty-adjust",function(){var a=$(this);setTimeout(function(){a.select()},50)});
    //     function updateQuantity(a,b){isUpdating=!0;var c=$('.ajaxcart__row[data-line="'+a+'"]').addClass("is-loading");0===b&&c.parent().addClass("is-removed"),setTimeout(function(){ShopifyAPI.changeItem(a,b,adjustCartCallback)},250)}
    //     $body.on("click","td.cart__update-wrapper a.cart__remove",function(){var a=$(this).closest("tr").data("line");return setTimeout(function(){ShopifyAPI.changeItem(a,0,adjustCartCallback)},250),$(this).closest("tr").remove(),$("tr.cart__row").each(function(a){a++,$(this).attr("data-line",a)}),!1});
    //     $body.on("change","input.js-qty__num",function(){var a=$(this).closest("tr").data("line"),b=$(this).val(),b=validateQty(b);a&&updateQuantity(a,b)});
    //     $body.on("click","div.js-qty button.apQtyAdjust ",function(){var a=$(this).closest("tr").data("line"),b=$(this).parent().children("input.js-qty__num").val(),b=validateQty(b);a&&updateQuantity(a,b)});
    //     $body.on("change",'textarea[name="note"]',function(){var a=$(this).val();ShopifyAPI.updateCartNote(a,function(a){})});
    // };


    $(".cart__remove-item a").click(function(){
        $('span.cart__checkout').show(100);
        $('button.cart__checkout').hide(100);
        var line = $(this).data('line');
        $.post('/cart/change.js', { quantity: 0, line: line }).always(function(res){
            $('form[action^="/cart"]').submit();
        });
        return false;
    });

    $(".cart__variant-product").each(function(i,e){
        var title = $(e).text();
        if(title.indexOf("Default") != -1){
            title = title.replace("Default Title", "");
            $(e).text(title);
        }
    });
});

function update_qty_item(obj){
        $("button.cart__checkout").hide(100);
        $("span.cart__checkout").show(100);

    // setTimeout(function () {
        var qty = $(obj).parent('.js-qty').find('.js-qty__num').val();
        var variant_id = $(obj).closest('.cart-item').attr('variant-id');
        console.log(qty);
        // console.log(variant_id);
        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: {
                quantity: qty,
                id: variant_id
            },
            success: function(cart) {

                if (typeof qbSwitchVariant === "function") { 
                    qbSwitchVariant(cart, function(res){
                        $( "button[name=update]" ).trigger( "click" );
                    });
                } else {
                    $( "button[name=update]" ).trigger( "click" );
                }
            },
            error: function(response) {
                console.log(response);
            }
        });
    // }, 500);
}

function showMoney(m) {
    if (m.toString().indexOf(".") == -1) {
        return (m + ".00");
    }
    return m;
}

function fbTrackATC(trackObj) {
    fbq('track', 'AddToCart', trackObj);
}
function fbTrack(el) {
    var wrapper = $(el).closest('.grid-product__wrapper');
    var productId = parseInt(wrapper.attr('data-id')),
    type = wrapper.attr('data-type'),
    price = wrapper.attr('data-money'),
    title = wrapper.attr('data-title');
    fbTrackATC({
        content_ids: [productId],
        content_type: 'product',
        currency: 'USD',
        content_name: title,
        content_category: type,
        value: price,
    });
    gtag('event', 'add_to_cart', {
        send_to: 'AW-797163746',
        dynx_pagetype: 'conversionintent',
        dynx_itemid: productId,
        dynx_totalvalue: price,
        dynx_category: type,
    });
}